<template>
  <Header />

  <Account />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Account from "@/components/Account.vue";

export default {
  name: "AccountView",
  components: {
    Header,
    Footer,
    Account,
  },
  created() { },
  computed: {},
  methods: {},
};
</script>
